import React, { Fragment, useState } from 'react'
import { Table } from 'Components/Table'
import { Td } from 'Components/Table/Td'
import { Th } from 'Components/Table/Th'
import { Tr } from 'Components/Table/Tr'
import { FilterSelect } from 'Components/Filter/FilterSelect'
import { CityPlansFiltersWrapper } from 'Components/Campaigns/Page/CityPlans/CityPlansFiltersWrapper'
import { Tooltip } from '@material-ui/core'
import InfoIcon from '@material-ui/icons/Info'

const sortTableColumns = (items, selectedCity, columnName, isReverse) => {
  const sortedItems = items
    .filter(({ cityId }) => (selectedCity ? cityId == selectedCity : true))
    .sort((a, b) =>
      a[columnName] > b[columnName]
        ? 1
        : b[columnName] > a[columnName]
        ? -1
        : 0,
    )

  if (isReverse) {
    return sortedItems.reverse()
  } else {
    return sortedItems
  }
}

const DetailedView = ({ data, formatCurrency }) => {
  const {
    bonusAllowance,
    bonusPerConversion,
    bonusPaidSoFar,
    bonusUsage,
    baResults,
  } = data.bonusResults

  const bonusResults = baResults

  const [state, setState] = useState({
    selectedCity: null,
    columnName: 'name',
    isReverse: false,
  })

  const bonusRemainder = parseFloat(bonusAllowance - bonusPaidSoFar).toFixed(2)

  const sortRows = sortTableColumns(
    bonusResults,
    state.selectedCity,
    state.columnName,
    state.isReverse,
  )

  const totalsRow = sortRows.reduce(
    (prev, cur) => {
      prev.missionsCount += cur.missionsCount
      prev.conversionsCount += cur.conversionsCount ? cur.conversionsCount : 0
      prev.totalBonusPaid += cur.totalBonusPaid
      return prev
    },
    {
      name: 'Totals',
      missionsCount: 0,
      conversionsCount: 0,
      totalBonusPaid: 0,
    },
  )

  const changeSort = event => {
    const columnName = event.target.id
    if (state.columnName == columnName) {
      setState(state => ({ ...state, isReverse: !state.isReverse }))
    } else {
      setState(state => ({
        ...state,
        columnName: columnName,
        isReverse: !state.isReverse,
      }))
    }
  }

  return (
    <Fragment>
      <CityPlansFiltersWrapper>
        <FilterSelect
          label="City"
          onChange={(element, index, value) => {
            setState(state => ({ ...state, selectedCity: value }))
          }}
          options={data.citiesOptions}
          value={state.selectedCity}
          sorted={true}
        />
      </CityPlansFiltersWrapper>
      {!bonusResults || bonusResults.length == 0 ? (
        <div style={{ marginTop: 10 }}>
          <span>There are no bonus results for this campaign.</span>
        </div>
      ) : null}
      <div>
        <div
          style={{
            display: 'flex',
            marginTop: 60,
            justifyContent: 'space-around',
          }}
        >
          <div className="kpi">
            <span>{`Bonus Allowance: ${formatCurrency(bonusAllowance)}`}</span>
          </div>

          <div className="kpi">
            <span>{`Bonus/conv: ${formatCurrency(
              parseFloat(bonusPerConversion).toFixed(2),
            )}`}</span>
          </div>
          <div className="kpi">
            <span>{`Bonus Remainder: ${formatCurrency(bonusRemainder)}`}</span>
          </div>
          <div className="kpi">
            <span>{`Bonus usage: ${bonusUsage}%`}</span>
          </div>
        </div>
        <Table>
          <thead>
            <Tr>
              <Th className="sortable" id={'name'} onClick={changeSort}>
                Name
              </Th>
              <Th
                className="sortable"
                id={'missionsCount'}
                onClick={changeSort}
              >
                <Tooltip title="Number of Completed and Paid missions">
                  <div>
                    <span># Missions</span>{' '}
                    <InfoIcon
                      fontSize="small"
                      style={{ verticalAlign: 'bottom' }}
                    />
                  </div>
                </Tooltip>
              </Th>
              <Th
                className="sortable"
                id={'conversionsCount'}
                onClick={changeSort}
              >
                # Conversions
              </Th>
              <Th
                className="sortable"
                id={'totalBonusPaid'}
                onClick={changeSort}
              >
                $ Total bonus paid
              </Th>
            </Tr>
          </thead>
          <tbody>
            {sortRows.map((row, key) => (
              <RenderRow key={key} row={row} />
            ))}
            <RenderRow row={totalsRow} />
          </tbody>
        </Table>
      </div>
    </Fragment>
  )
}
const RenderRow = ({ row }) => (
  <Tr>
    <Td>{row.name}</Td>
    <Td>{row.missionsCount}</Td>
    <Td>
      {row.conversionsCount === null ? 'Not updated' : row.conversionsCount}
    </Td>
    <Td>{parseFloat(row.totalBonusPaid).toFixed(2)}</Td>
  </Tr>
)

export default DetailedView
